import CoreUtils from '../../../utils/coreUtils.js';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GlobalDefs from '../../../globalDefs.js';
import AssetCacher, { ASSET_TYPE } from '../assetCacher.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeFile extends Node
{
	constructor(pParent)
	{
		super(pParent);

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pAssetChoices = pAssetProvider.get3DAssetList();

		let defaultChoice = '';
		if(pAssetChoices.length > 0)
			defaultChoice = pAssetChoices[0].key;
		this.addInput(PARAM_TYPE.DROPDOWN_3D_MODEL, 'file', defaultChoice, { dropdownOptions: pAssetChoices });
		this.addInput(PARAM_TYPE.FLOAT, 'quality', 0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{
		return 'file';
	}

	getIsLoading()
	{
		return AssetCacher.getInstance().getIsNodeLoading(this);
	}

	getReferencedAssetIds(resMapOut)
	{
		let assetKey = this.getLastInputResult('file');
		if(assetKey && assetKey != GlobalDefs.g_strNoneKey && resMapOut['asset3dIds'].indexOf(assetKey) < 0)
			resMapOut['asset3dIds'].push(assetKey);
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let strSelectedKey = inputValues['file'];
		if(!strSelectedKey || strSelectedKey.length === 0 || strSelectedKey === GlobalDefs.g_strNoneKey)
			return null;

		let pCachedMeshes = AssetCacher.getInstance().getCachedAsset(ASSET_TYPE.COMPONENT, strSelectedKey, scene, inputValues['quality']/100, this);
		if(pCachedMeshes)
		{
			let newMeshes = [];
			pCachedMeshes.forEach((pCachedMesh) =>
			{
				let pNewInstance = Utils3D.cloneMesh(pCachedMesh, this.getGeneratedMeshName(), false);
				delete pNewInstance.isCached;
				pNewInstance.scaling = new BABYLON.Vector3(GlobalDefs.fGlobalInputScale, GlobalDefs.fGlobalInputScale, GlobalDefs.fGlobalInputScale);
				this.onMeshCreated(pNewInstance);
				pNewInstance.name += pCachedMesh.name;
				newMeshes.push(pNewInstance);
			});
			return newMeshes;
		}

		const pAssetProvider = this.getGraph().getAssetProvider();
		const pFileInfo = pAssetProvider.get3DAsset(inputValues['file']);
		let strFullPath;
		let extraData = null;
		if(pFileInfo)
		{
			strFullPath = pFileInfo.file;
			extraData = pFileInfo.extraModelInfo;
		}
		if(!strFullPath || strFullPath == '')
			return null;
		
		AssetCacher.getInstance().getBabylonAsset(this, ASSET_TYPE.COMPONENT, strSelectedKey, scene, inputValues['quality']/100, 
			() => {	this.getGraph().onStartLoadingAsset(); }, 
			(newMeshes) => 
			{
				if(newMeshes)
				{
					newMeshes.forEach((pMesh) =>
					{
						if(pFileInfo && pFileInfo.extraModelInfo)
							pMesh.extraModelInfo = CoreUtils.clone(extraData);
					});
				}
				this.markDirty();
				this.getGraph().onFinishLoadingAsset();
			}
		);

		return null;
	}
}